
import TileLayer from 'ol/layer/Tile';
import { BasemapSource } from '../../bgis/ol/source/BasemapSource';
 

 

export const basemapGrayLayer = new TileLayer({
        source: new BasemapSource({ variant: 'bmapgrau' }),
        visible: true,
    })
 



